import requests from "./httpService";

const LeadPipelineService = {
  transitionStage(id, body) {
    return requests.post(`/crm-leads/${id}/stage`, body);
  },
  reopenLead(id, body) {
    return requests.post(`/crm-leads/${id}/reopen`, body);
  },
  logActivity(id, body) {
    return requests.post(`/crm-leads/${id}/activities`, body);
  },
  getActivities(id, companyId) {
    return requests.get(`/crm-leads/${id}/activities?company_id=${companyId}`);
  },
  snoozeLead(id, body) {
    return requests.post(`/crm-leads/${id}/snooze`, body);
  },
  getActionQueue(companyId, hideSnoozed = true) {
    return requests.get(`/crm-leads/action-queue?company_id=${companyId}&hide_snoozed=${hideSnoozed ? "1" : "0"}`);
  },
  getInterestCatalog(companyId) {
    return requests.get(`/crm-leads/interest-catalog?company_id=${companyId}`);
  },
  addInterestItem(body) {
    return requests.post(`/crm-leads/interest-catalog`, body);
  },
  deleteInterestItem(id, companyId) {
    return requests.delete(`/crm-leads/interest-catalog/${id}?company_id=${companyId}`);
  },
};

export default LeadPipelineService;
